var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditLine = function SvgEditLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2F64",
    d: "M31.6 37.8H2.2a2.1 2.1 0 1 0 0 4.2h29.4a2.1 2.1 0 1 0 0-4.2M2.2 33.6h.189l8.757-.798a4.2 4.2 0 0 0 2.54-1.197l18.9-18.9a4.03 4.03 0 0 0-.146-5.691L26.686 1.26a4.2 4.2 0 0 0-5.586-.147l-18.9 18.9a4.2 4.2 0 0 0-1.197 2.541L.1 31.311a2.1 2.1 0 0 0 .609 1.68 2.1 2.1 0 0 0 1.49.609M23.767 4.2 29.5 9.933l-4.2 4.095L19.672 8.4zM16.9 11.172 5.077 22.911 4.51 29.19l6.3-.588 11.76-11.76z"
  })));
};
export default SvgEditLine;